import styled from 'styled-components';

export const StyledIndustry = styled.div`
    padding: 200px 0 200px;
    position: relative;
    background: #152637;

    &.version_two {
        background: #DD223F;
        padding: 200px 0 200px;

    }

    &.version_three {
        background: #EFEFEF;
        padding: 200px 0 200px;

        .subtitle-ygen {
            color: #15263780;
        }

        .mb80.row {
            position: relative;
            padding-top: 40px;

            &:after {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                content: '';
                height: 1px;
                background: #15263780;
                width: calc(100% - 25px);
                margin: 0 auto;
            }
        }

    }

    .subtitle-ygen {
        color: #FFFFFF80;
    }

    .fixed-left {
        position: absolute;
        left: 0;
        top: 0;
		
    }

    .navigation-item {
        margin-top: 40px;
        display: none !important;
    }

    @media (max-width: 767px) {
        padding: 120px 0 !important;
		.container{
			position: relative;
			z-index: 3;
		}
        .mobile-justify {
            justify-content: flex-start !important;

            .navigation-item {
                gap: 15px;
                display: flex !important;
            }
        }
    }


`;
